import { writable } from "svelte/store";

export interface Event {
  event: {
    name: string;
    id: string;
    timestamp: string;
  };
  context: {
    sessionId: string;
    userAgent: string;
  };
  entities: any;
}

export interface Events extends Array<Event> {}

export const TrackingEventStore = writable<Events | []>([]);
